import React from "react";
import supplyChainImage from "../../../../assets/images/Landing_Page/selectezi_supply_chain.png";

const businessStages = [
  "RAW MATERIAL",
  "MANUFACTURER",
  "PACKAGING",
  "TRANSPORTATION",
  "WHOLESALER",
  "RETAILER",
  "CUSTOMER",
];

export default function WhatIs() {
  return (
    <section className="section-py bg-lavender what-is-section">
      <div className="container text-center">
        <h2 className="section-title">
          Every Business Sector Connected Through SELECTEZI
        </h2>
        <p className="section-subtitle what-is-intro">
          SELECTEZI brings different sectors into one connected ecosystem
          <br />
         &nbsp; Each sector can be both a resource provider and a resource seeker
        </p>

        <div
          className="what-is-flow mt-5"
          aria-label="Connected business sectors"
        >
          <div className="what-is-flow-content">
            <ol className="what-is-stages">
              {businessStages.map((stage) => (
                <li key={stage}>{stage}</li>
              ))}
            </ol>
            <img
              className="what-is-supply-chain-image"
              src={supplyChainImage}
              alt="Raw materials move through manufacturers, packaging, transportation, wholesalers, and retailers to customers."
            />
          </div>
        </div>

        <p className="what-is-summary mt-4">
          <b>SELECTEZI</b> <span aria-hidden="true">·</span>Connecting All Sectors{" "}
          <span aria-hidden="true">·</span> Two-Way Resource Exchange{" "}
          <span aria-hidden="true">·</span> Unified Ecosystem Platform
        </p>
      </div>
    </section>
  );
}
